<template>
  <div class="bg-white shadow-sm pt-2 pb-3" style="border-radius: 20px">
    <div class="d-flex align-items-center">
      <div class="px-4 d-flex align-items-center پml-auto">
        <div class="p-2 ml-auto">آمار ماهانه</div>
      </div>
    </div>
    <hr />
    <div id="chart"></div>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import $ from 'jquery';

export default {
  name: "chart",
  props: ["chart_data"],
  methods: {
    getColors() {
      let arr = [];

      for (let i = 0; i < 30; ++i) {
        arr.push("#888");
      }

      return arr;
    },
  },
  mounted() {
    window.app_chart_data_axis = [];

    for (let i = 0; i < 30; ++i) {
      window.app_chart_data_axis.push(this.chart_data.axis[i].slice(-2));
      // this.chart_data.succeeded_count[i] = [i + 1, this.chart_data.succeeded_count[i]];
    }

    let options = {
      chart: {
        defaultLocale: 'fa',
        locales: [{
          "name": "fa",
          "options": {
            "months": [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ],
            "shortMonths": [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ],
            "days": [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday"
            ],
            "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "toolbar": {
              "exportToSVG": "خروجی svg",
              "exportToPNG": "خروجی png",
              "exportToCSV": "خروجی excel",
              "menu": "Menu",
              "selection": "Selection",
              "selectionZoom": "Selection Zoom",
              "zoomIn": "Zoom In",
              "zoomOut": "Zoom Out",
              "pan": "Panning",
              "reset": "Reset Zoom"
            }
          }
        }],

        zoom: {
          enabled: false,
        },
        height: 350,
        type: "line",
        stacked: false,
        fontFamily: "IRANSansFaNum",
      },

      dataLabels: {
        enabled: false,
      },

      colors: ["#00bea5", "transparent"],

      series: [
        {
          name: 'مبلغ',
          data: this.chart_data.succeeded,
        },

        {
          name: 'تعداد تراکنش موفق',
          data: this.chart_data.succeeded_count,
        },
      ],

      stroke: {
        curve: "smooth",
        width: 3,
      },

      legend: {
        show: false,
      },

      yaxis: {
        labels: {
          style: {
            colors: this.getColors(),
          },
          formatter: value => {
            if (value < 1000) {
              return value;
            }

            if (value < 1000000) {
              return String(Math.ceil(value / 100) / 10) + 'k';
            }

            return String(Math.ceil(value / 100000) / 10) + 'm';
          },
        },
      },

      xaxis: {
        labels: {
          style: {
            colors: this.getColors(),
          },
          formatter: value => {
            return window.app_chart_data_axis[value - 1];
          },
        },
      },
    };

    let chart = new ApexCharts(document.querySelector("#chart"), options);

    chart.render();
  },
};
</script>

<style>
#chart {
  max-width: 700px;
  max-height: 200px;
  margin: auto;
}
</style>